import { groupBy } from "lodash";
import moment from "moment";
import { Blackout } from "../models/blackout";

const days = [
  "Domingo",
  "Lunes",
  "Martes",
  "Miércoles",
  "Jueves",
  "Viernes",
  "Sábado",
];
const months = [
  "Enero",
  "Febrero",
  "Marzo",
  "Abril",
  "Mayo",
  "Junio",
  "Julio",
  "Agosto",
  "Septiembre",
  "Octubre",
  "Noviembre",
  "Diciembre",
];
export const daysShort = days.map((month) => month.substring(0, 3));
export const monthsShort = months.map((month) => month.substring(0, 3));

export const getTime = (date = new Date()) => {
  return {
    year: date.getFullYear(),
    month: date.getMonth() + 1,
    monthStr: months[date.getMonth()],
    day: date.getDate(),
    dayStr: days[date.getDay()],
    hour: date.getHours(),
    minutes: date.getMinutes(),
    seconds: date.getSeconds(),
  };
};

export const getDateFirstDay = (date = new Date()) =>
  new Date(date.getFullYear(), date.getMonth(), 1);

export const getTimeWithBlackout = (blackout: Blackout) => {
  const range1 = blackout.start.split(":");
  const range2 = blackout.end.split(":");
  return {
    start: { hour: Number(range1[0]), minute: Number(range1[1]) },
    end: { hour: Number(range2[0]), minute: Number(range2[1]) },
  };
};

export const inRange = ({ start, end }) => {
  const current = getTime();
  const time = parseInt(
    `${current.hour < 10 ? "0" : ""}${current.hour}${
      current.minutes < 10 ? "0" : ""
    }${current.minutes}`
  );
  console.log("time", time);
  return time >= parseInt(start.replace(":", "")) &&
    time <= parseInt(end.replace(":", ""))
    ? true
    : false;
};

export const getWeekNumberDay = (date) => moment(date).day();

export const getDateFormat = (date, lte = false) => {
  if (lte) date[0].setHours(23, 59, 59);
  return moment(date[0]).format("YYYY-MM-DD HH:mm:ss");
};

const getRandom = (min, max) => Math.floor(Math.random() * (max - min) + min);

export const getDayName = (day: number): string => days[day];

export const getMonthName = (month: number): string =>
  months[Number(month) - 1];

export const fillMonths = (list: any[], min: number, max: number) => {
  const months = groupBy(list, "month");
  const data = [];
  for (let i = min; i <= max; i++) {
    data.push(months[i] ? Number(months[i][0].total) : 0);
  }
  return data;
};

export const isValidScheduledDate = (date, delay = 5) => {
  const currentDate = moment().add(delay, "minutes"); // todo 5min
  const scheduledTime = moment(date); // todo tz
  console.log(
    "\nValidate date",
    currentDate.toISOString(),
    scheduledTime.toISOString()
  );
  return scheduledTime.isSameOrAfter(currentDate);
};

export const timeUntil = (date: Date | string) => {
  const duration = moment.duration(moment(date).diff(moment()));
  return {
    days: Math.floor(duration.asDays()),
    hours: duration.hours(),
    minutes: duration.minutes(),
  };
};

export const getDateOffset = (tz?: string) => {
  let time = tz ? moment().tz(tz) : moment();
  const offset = time.utcOffset();
  const hours = Math.abs(Math.floor(offset / 60));
  const sign = hours > 0 ? "-" : "+";
  return `GMT${sign}${hours}`;
};
